import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkedPipe',
})
export class CheckedPipe implements PipeTransform {
  transform(checkedArray: string[], item: string): boolean {
    return checkedArray.some((i) => i === item);
  }
}
